var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullTimeNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.433v2.834c0 .729-.525 1.357-1.248 1.453a32.299 32.299 0 0 1-8.504 0c-.723-.096-1.248-.724-1.248-1.453V9.433m11 0a1.453 1.453 0 0 0 .5-1.107V5.804c0-.72-.512-1.343-1.225-1.45-.755-.113-1.514-.2-2.275-.258m3 5.337c-.13.11-.28.197-.449.254-1.629.54-3.334.815-5.051.813a16 16 0 0 1-5.051-.813 1.344 1.344 0 0 1-.449-.254m0 0A1.453 1.453 0 0 1 2 8.326V5.804c0-.72.512-1.343 1.225-1.45.755-.113 1.514-.2 2.275-.258m5 0V3.5A1.5 1.5 0 0 0 9 2H7a1.5 1.5 0 0 0-1.5 1.5v.596m5 0a32.445 32.445 0 0 0-5 0M8 8.5h.005v.005H8V8.5z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTimeNewIcon);
export default __webpack_public_path__ + "static/media/full-time-new-icon.6bf39f3ea0db726ba6b6263434e04a63.svg";
export { ForwardRef as ReactComponent };